<template>
    <v-container fluid class="fill-height pa-0" width="100%">
        <v-card  color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black" v-if="edit == true">Edit Party</v-toolbar-title>
                 <v-toolbar-title class="font-weight-black" v-else>Add New Party</v-toolbar-title>
                    <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn color="black" class="amber--text" @click="save()" :loading="isLoading">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-form class="pa-5">
                <v-row dense>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="personName" label="Contact Person" outlined color="amber"></v-text-field>
                    </v-col>

                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-select :items="['Broker','Trader','Firm']" v-model="bussinessType" label="Bussiness Type" outlined color="amber"></v-select>
                    </v-col>
                    <v-col md=12 sm=12 cols=12 class="py-0">
                        <v-text-field v-model="companyName" label="Company Name" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="phone" label="Phone" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field type="email" v-model="email" label="Email" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="address" label="Address" outlined color="amber"></v-text-field >
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="city" label="City" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="state" label="State" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="pincode" label="Pincode" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="gst" label="GST" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="bankName" label="Bank Name" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="bankAc" label="Bank AC" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="ifsc" label="Bank IFSC Code" outlined color="amber"></v-text-field>
                    </v-col>
                </v-row>
            </v-form> 
        </v-card>
        <span style="display:none;">{{checkfetch}}</span>
    </v-container>
</template>

<script>
import { SERVER_API } from "../../API/";
export default {
    created(){
        window.addEventListener('keyup', event => {
            if(event.which === 27){
                this.Close();
            }
            if(event.which === 13){
                this.Save();
            }
        })
    },
    props:['id','edit'],
    data(){
        return{
            bussinessType:'',
            personName:'',
            companyName:'',
            phone:'',
            email:'',
            gst:'',
            state:'',
            city:'',
            address:'',
            pincode:'',
            bankName:'',
            bankAc:'',
            ifsc:'',
            isLoading:false,
        }
    },
    watch:{
        statusHere(val){
            if(val == true){
                this.status = 1;
            }else{
                this.status = 0;
            }
        }
    },
    computed:{
        checkfetch(){
            return this.fetchById();
        }
    },
    methods:{
         reset(){
            this.bussinessType = '';
            this.personName = "";
            this.companyName = "";
            this.phone = "";
            this.email = "";
            this.gst = "";
            this.state = "";
            this.city = "";
            this.address = "";
            this.pincode = "";
            this.bankName = "";
            this.bankAc = "";
            this.ifsc = "";
        },
        Close(){
            this.reset()
            this.$emit('Close',false);
        },
        async fetchById(){
            if(this.edit == true){
                const response = await this.$http.get(SERVER_API+'/party/byid/'+this.id);
                this.personName = response.data.data.personName;
                this.companyName = response.data.data.companyName;
                this.phone = response.data.data.phone;
                this.email = response.data.data.email;
                this.gst = response.data.data.gst;
                this.state = response.data.data.state;
                this.city = response.data.data.city;
                this.address = response.data.data.address;
                this.pincode = response.data.data.pincode;
                this.bankName = response.data.data.bankName;
                this.bankAc = response.data.data.bankAc;
                this.ifsc = response.data.data.ifsc;
                this.bussinessType = response.data.data.bussinessType;
            }
        },
        async save(){
            if(this.edit == true){
                try{
                    this.isLoading = true;
                    const response = await this.$http.put(SERVER_API+'/party/update',{
                        id:this.id,
                        personName: this.personName,
                        companyName: this.companyName,
                        phone: this.phone,
                        email: this.email,
                        gst: this.gst,
                        state: this.state,
                        city: this.city,
                        address: this.address,
                        pincode: this.pincode,
                        bankName: this.bankName,
                        bankAc: this.bankAc,
                        ifsc: this.ifsc,
                        bussinessType: this.bussinessType
                    });
                    this.isLoading = false;
                    this.$emit('Response',response.data);
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response',error);
                }
            }else{
                try{
                    this.isLoading = true;
                    const response = await this.$http.post(SERVER_API+'/party/create',{
                        personName: this.personName,
                        companyName: this.companyName,
                        phone: this.phone,
                        email: this.email,
                        gst: this.gst,
                        state: this.state,
                        city: this.city,
                        address: this.address,
                        pincode: this.pincode,
                        bankName: this.bankName,
                        bankAc: this.bankAc,
                        ifsc: this.ifsc,
                        bussinessType: this.bussinessType
                    });
                    this.isLoading = false;
                    this.reset()
                    this.$emit('Response',response.data);
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response',error);
                }
            }
        }
    }

}
</script>

<style>

</style>